import { Pagination, SearchInput } from "ui";

import { InventoryInsightsTable } from "../../components";
import { useInventoryInsightsList } from "../../hooks";

import styles from "./InventoryInsights.module.scss";

const InventoryInsights = () => {
  const {
    inventoryInsightsProducts,
    isLoading,
    sorting,
    setSorting,
    refetch,
    totalItems,
    searchValue,
    page,
    setSearchValue,
    setPage
  } = useInventoryInsightsList();

  return (
    <div className={styles.inventoryInsights}>
      <SearchInput
        value={searchValue}
        placeholder="Search..."
        onChange={setSearchValue}
      />

      <div className={styles.inventoryInsights_tableContainer}>
        <InventoryInsightsTable
          products={inventoryInsightsProducts ?? []}
          isLoading={isLoading}
          sorting={sorting}
          setSorting={setSorting}
          refetchInventoryInsights={refetch}
        />
      </div>

      <Pagination
        currentPage={page}
        onChange={setPage}
        totalItems={totalItems}
      />
    </div>
  );
};

export default InventoryInsights;
